var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
export const useFilespaceDeleteVerificationCode = ({ onError, onSuccess, } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const mutation = useMutation({
        mutationFn: ({ filespaceId, workspaceId }) => lucidSdk
            .workspaceClient(workspaceId)
            .sendFilespaceDeleteVerificationCode(filespaceId),
        onSuccess: () => {
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useFilespaceDeleteVerificationCode, "BQaElb9uT0+pguh7S8aDatOYRp8=", false, () => [useLucidSdk, useMutation]);
